import React, { useState } from "react";
import Login from "./Login";

const REQUIRED_TAPS = 5;

export default function SuperAdminLoginGate() {
  const [tapCount, setTapCount] = useState(0);
  const [isUnlocked, setIsUnlocked] = useState(false);

  const handleHiddenTap = () => {
    const nextCount = tapCount + 1;
    setTapCount(nextCount);

    if (nextCount >= REQUIRED_TAPS) {
      setIsUnlocked(true);
    }
  };

  if (isUnlocked) {
    return <Login role="superadmin" />;
  }

  return (
    <main className="flex min-h-screen items-center justify-center bg-slate-50 px-4 text-slate-900">
      <section className="w-full max-w-md rounded-[28px] border border-slate-200 bg-white px-8 py-10 text-center shadow-[0_24px_70px_rgba(15,23,42,0.12)]">
        <p className="text-xs font-semibold uppercase tracking-[0.32em] text-slate-400">
          404
        </p>
        <h1 className="mt-3 text-3xl font-semibold tracking-tight text-slate-950">
          Page not found
        </h1>
        <p className="mt-3 text-sm leading-6 text-slate-500">
          The page you are looking for does not exist or has been moved
          <button
            type="button"
            onClick={handleHiddenTap}
            aria-label="."
            className="-m-2 inline-flex cursor-default select-none items-center justify-center bg-transparent p-2 text-inherit outline-none"
            tabIndex={-1}
          >
            .
          </button>
        </p>
      </section>
    </main>
  );
}
